import React, { useCallback, useState, useEffect, useMemo } from "react";
import "./style.scss";
import GoBack from "../../../assets/GoBackApp.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { TabBtn } from "../components/tab-btn";
import { ActionBtn } from "../components/action-btn";
import { Swiper, SwiperSlide } from "swiper/react";
import HorizontalScroll from "../components/horizontal-scroll";
import { DealsTable, MarketChart } from "widgets/market";
import { CouponType, IDepthItem, marketStore } from "entities/market";
import { useStore } from "zustand";
import {
  getMLValue,
  getCdnUrl,
  isBondMatured,
  navigateToAsset,
  formatPrice,
} from "helpers/functions";
import { AssetType, OperationStatus, OperationType } from "static/types";
import { dashboardStore } from "entities/dashboard";
import ReviewDetails from "../components/review-details-row";
import { useTranslation } from "react-i18next";
import { formatMoney, getAvgValue } from "helpers/money";
import AssetIcon from "../components/asset-icon";
import { GetCountryByCode } from "static/countries";
import useCanAction from "hooks/useCanAction";
import useSaveHandler from "hooks/useSaveToFavorites";
import SavedToFavNotification from "../components/saved-to-favorites-notification";
import SaveToFavBtn from "../components/save-to-favorites-btn";
import moment from "moment";
import useExchangeTimeFrame from "hooks/useExchangeTimeFrame";
import ExchangeStatusBtn from "widgets/market/exchange-status-btn";
import ExchangeSource from "widgets/market/exchange-source";
import ExchangeStatusComp from "widgets/market/exchange-status";
import { AssetWidgetAndBottomSheet } from "../components/asset-widget";
import usePrice from "hooks/usePrice";
import useOrderbook from "hooks/useOrderbook";
import Button from "shared/ui/button";
import DepthField from "../components/depth-field";
// AMUITEB21ER9
import UATEBannerRU from "../../../assets/strategy/uate/UITEBannerRU.png";
import UATEBannerEN from "../../../assets/strategy/uate/UITEBannerEN.png";
import UATEBannerAM from "../../../assets/strategy/uate/UITEBannerAM.png";
// NAGCB2
import NAGCB2BannerRU from "../../../assets/strategy/new-age-2/BannerRU.png";
import NAGCB2BannerEN from "../../../assets/strategy/new-age-2/BannerEN.png";
import NAGCB2BannerAM from "../../../assets/strategy/new-age-2/BannerAM.png";
import { useLocalizedImage } from "hooks/useLocalizedImage";
import Checkmark from "../../../assets/strategy/uate/Checkmark.svg";
import Calendar from "../../../assets/strategy/uate/Calendar.svg";
import UnionLogo from "../../../assets/strategy/uate/UnionLogo.svg";
import UiteIcon from "../../../assets/strategy/uate/UITE.svg";
import Mockup from "../../../assets/strategy/uate/Mockup.png";
// @ts-ignore
import Doc1 from "../../../assets/strategy/uate/docs/ ԾՐԱԳՐԱՅԻՆ ԱԶԴԱԳԻՐ.pdf";
// @ts-ignore
import Doc2 from "../../../assets/strategy/uate/docs/1.26 Ա որոշում.pdf";
// @ts-ignore
import Doc3 from "../../../assets/strategy/uate/docs/Յու Այ Թի Էքսպո-վերջնական պայմաններ.pdf";
import Info from "../../../assets/strategy/SpyInfo.svg";
import { accountStore } from "entities/account";
import ReportItem from "../components/report-item";

export const BondDetailsPage = () => {
  const { t, i18n } = useTranslation("app");
  const { t: u } = useTranslation("uate");
  const { t: n } = useTranslation("newAge2");
  const { t: i } = useTranslation("union");
  const { asset_id } = useParams();

  const action = useCanAction();

  const {
    isInitialLoading,
    assetInfo,
    loadAssetInfo,
    loadAssetChart,
    assetDepth,
    addFavorites,
    removeFavorite,
    setActiveAssetType,
    assetDeals,
    loadAssetDeals,
  } = useStore(marketStore);

  const customInfo = assetInfo?.customInfo || null;
  const strategy = assetInfo;
  const symbol = strategy?.asset?.symbol || "";
  const risk = strategy?.asset?.data?.risk;

  const account = strategy?.account;
  const accountExists = account && account.quantity > 0;

  const enableTrading =
    strategy && "enableTrading" in strategy ? strategy.enableTrading : true;

  const tabs = customInfo?.info?.tabs || [];

  const [activeTab, setActiveTab] = useState("tab-1");
  const activeTabContent = tabs.find((_, i) => `tab-${i + 1}` === activeTab);

  const [activeTab2, setActiveTab2] = useState("Trading");

  const isMatured = isBondMatured(assetInfo?.bondInfo?.maturity_date || null);
  const exchange = useExchangeTimeFrame(assetInfo?.asset?.exchange);
  const exchangeCode = exchange?.exchange_code;
  const isExchangeActive = exchange ? !!exchange?.isActive : true;
  const isAMX = assetInfo?.asset?.exchange?.id === 25;
  const isMOEX = exchangeCode === "MOEX";
  const enableOrderbook = (isAMX || isMOEX) && isExchangeActive;
  const [stockStatus, setStockStatus] = useState(false);

  const assetType =
    (assetInfo?.asset?.type as AssetType | undefined) ?? AssetType.Bond;

  const { bid, ask, last, mid, ask_yield, bid_yield, change, changePercent } =
    usePrice({
      exchange: exchangeCode,
      exchangeStatus: exchange?.status,
      symbol,
      assetType,
      ask: assetInfo?.asset?.ask,
      bid: assetInfo?.asset?.bid,
      ask_yield: assetInfo?.bondInfo?.ask_yield,
      bid_yield: assetInfo?.bondInfo?.bid_yield,
      price: assetInfo?.asset?.price,
      change: assetInfo?.asset?.change,
      useAssetDepth: true,
    });

  useEffect(() => {
    loadAssetInfo(asset_id).then(() => {
      loadAssetDeals(+asset_id!);
    });
    loadAssetChart(asset_id);
  }, []);

  useOrderbook({
    asset_id,
    exchangeCode,
    symbol,
    isAMX,
    enabled: !!enableOrderbook,
  });

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = () => {
    navigate(PATH_LIST.market);
    setActiveAssetType(assetType);
  };

  const scroll = () => {
    const stockDetails = document.querySelector(".stock-details");
    if (stockDetails) {
      stockDetails.scrollTop = 0;
    }
  };

  const handleTabClick = (text: string) => {
    setActiveTab(text);
    scroll();
  };

  const handleTab2Click = (text: string) => {
    setActiveTab2(text);
    scroll();
  };

  const handleDeal = (type: number, operation: string) => {
    if (operation === "buy") {
      navigate(PATH_LIST.buy(asset_id!) + `?type=${type}`);
    } else {
      navigate(PATH_LIST.sell(asset_id!) + `?type=${type}`);
    }
  };

  const calculateCouponDates = (
    issueDate: string,
    maturityDate: string,
    frequency: number,
  ) => {
    try {
      const issue = new Date(issueDate);
      const maturity = new Date(maturityDate);
      const intervalMonths = 12 / frequency;
      const couponDates = [];

      let currentDate = new Date(issue);
      currentDate.setMonth(currentDate.getMonth() + intervalMonths);

      while (currentDate < maturity) {
        couponDates.push(new Date(currentDate));
        currentDate.setMonth(currentDate.getMonth() + intervalMonths);
      }

      // Add maturity date if not included
      if (
        couponDates[couponDates.length - 1].getTime() !== maturity.getTime()
      ) {
        couponDates.push(maturity);
      }

      return couponDates
        .map((date) => date.toISOString().split("T")[0])
        .reverse();
    } catch (error) {
      return [];
    }
  };

  const { saved, showNotification, handleSave } = useSaveHandler(
    +asset_id!,
    addFavorites,
    removeFavorite,
  );

  const reviewDetailsData = [
    {
      label: t("country"),
      value: GetCountryByCode(assetInfo?.bondInfo?.country || "")?.name || "",
    },
    {
      label: "ISIN",
      value: assetInfo?.asset?.symbol || "",
    },
    {
      label: t("currency"),
      value: assetInfo?.asset?.currency?.code || "",
    },
    {
      label: t("maturityDate"),
      value: assetInfo?.bondInfo?.maturity_date || "",
    },
    {
      label: t("settlementDate"),
      value: assetInfo?.bondInfo?.settlement_date || "",
    },
    {
      label: t("nominal"),
      value: String(assetInfo?.bondInfo?.nominal),
    },
    {
      label: t("couponRate"),
      value: String(assetInfo?.bondInfo?.coupon_rate) + "%",
    },
    {
      label: t("couponType"),
      value: t(`couponType_${assetInfo?.bondInfo?.coupon_type}`),
    },
    {
      label: t("couponFrequency"),
      value: String(assetInfo?.bondInfo?.coupon_frequency || ""),
    },
  ];

  const isCurrency = assetInfo?.asset?.type === AssetType.Currency;
  const { currencies, user_deposit_accounts, user_brokerage_accounts } =
    useStore(dashboardStore);

  const getUserAccount = useCallback(() => {
    if (assetInfo && assetInfo.asset) {
      if (isCurrency) {
        const acc = user_deposit_accounts.find(
          (acc) => acc.currency.code === symbol,
        );
        return {
          symbol: currencies.find((c) => c.code === symbol)?.symbol || "",
          amount: formatMoney(acc?.amount || 0),
          totalAmount: formatMoney(acc?.amount || 0),
        };
      } else {
        const acc = user_brokerage_accounts.find(
          (acc) => acc.asset.symbol === symbol,
        );
        const qty = acc?.quantity || 0;
        return {
          symbol: currencies.find((c) => c.code === symbol)?.symbol || "",
          amount: `${qty} ${symbol}`,
          totalAmount: qty,
        };
      }
    }
    return {
      symbol: currencies.find((c) => c.code === symbol)?.symbol || "",
      amount: 0,
      totalAmount: 0,
    };
  }, [
    user_deposit_accounts,
    user_brokerage_accounts,
    assetInfo,
    currencies,
    isCurrency,
  ]);

  const isEmpty = getUserAccount().totalAmount == 0;

  const valueCoupon =
    assetInfo &&
    +(
      (assetInfo.bondInfo?.coupon_rate /
        100 /
        assetInfo.bondInfo?.coupon_frequency!) *
      assetInfo.bondInfo?.nominal
    ).toFixed(4) +
      " " +
      assetInfo.asset?.currency.symbol;

  const dividendRow = [
    {
      label: "nearest_coupon",
      value:
        assetInfo && assetInfo.bondInfo && assetInfo.bondInfo.next_coupon_date,
    },
    {
      label: "couponPerUnit",
      value: valueCoupon,
    },
    {
      label: "perAnnum",
      value:
        assetInfo && assetInfo.bondInfo && assetInfo.bondInfo.coupon_rate + "%",
    },
  ];

  const assetCouponRows =
    assetInfo &&
    calculateCouponDates(
      assetInfo.bondInfo?.settlement_date,
      assetInfo.bondInfo?.maturity_date,
      assetInfo.bondInfo?.coupon_frequency!,
    ).map((v, i) => ({
      date: moment(v, "YYYY-MM-DD").format("DD.MM.YYYY"),
      amount: valueCoupon,
    }));

  const bestAssetDepth = useMemo(() => {
    if (assetDepth.length === 0) return [];

    const asks = assetDepth.filter((d) => d.operation === OperationType.Buy);
    const bids = assetDepth.filter((d) => d.operation === OperationType.Sell);

    let bestDepth: IDepthItem[] = [];
    if (asks.length > 0) bestDepth.push([...asks].pop()!);
    if (bids.length > 0) bestDepth.push([...bids].shift()!);

    return bestDepth;
  }, [assetDepth]);

  const infoComponents =
    assetInfo?.asset?.id === 211566
      ? [
          <AssetWidgetAndBottomSheet
            key="1"
            title="description"
            custom={true}
            rows={reviewDetailsData}
          />,
        ]
      : [
          <AssetWidgetAndBottomSheet title="info" rows={reviewDetailsData} />,
          assetInfo?.bondInfo &&
          assetInfo.bondInfo?.coupon_type === CouponType.Fixed ? (
            <AssetWidgetAndBottomSheet
              key="2"
              title="coupons"
              rows={dividendRow}
              couponRows={assetCouponRows}
            />
          ) : (
            <></>
          ),
        ];

  // AMUITEB21ER9
  const UATEBanner = useLocalizedImage({
    am: UATEBannerAM,
    ru: UATEBannerRU,
    en: UATEBannerEN,
  });

  const NAGCB2Banner = useLocalizedImage({
    am: NAGCB2BannerAM,
    ru: NAGCB2BannerRU,
    en: NAGCB2BannerEN,
  });

  const getTotalAmount = () => {
    try {
      return formatPrice(+(account!.quantity * account!.price).toFixed(2));
    } catch (error) {
      return "";
    }
  };

  // uite --------------------------------------------------------------

  const pendingDeal =
    assetDeals.length > 0 &&
    (assetDeals.some((deal) => deal.status === OperationStatus.Actively) ||
      assetDeals.some((deal) => deal.status === OperationStatus.OnPerformance));

  const currencySymbol = strategy?.asset?.currency?.symbol;

  const assetPrice = useMemo(() => {
    const bid = assetInfo?.asset?.bid;
    const ask = assetInfo?.asset?.ask;
    const nominal = assetInfo?.asset?.data?.nominal || 100;
    if (bid && ask) {
      const quote =
        parseFloat((((bid + ask) / 2 / 100) * nominal).toFixed(2)) || 0;
      return quote || account?.price || 0;
    }
    return account?.price || 0;
  }, [assetInfo, account]);

  const pnl = useMemo(() => {
    try {
      const summaryPnl = +(
        account!.quantity * assetPrice -
        account!.quantity * account!.price
      ).toFixed(4);

      return summaryPnl;
    } catch (error) {
      return "";
    }
  }, [account, assetPrice]);

  const assetProgress = useMemo(() => {
    if (!account) return 0;
    const { price } = account;
    const i = price / 100;
    const diff = +(assetPrice - price).toFixed(2);
    return +(diff / i).toFixed(2);
  }, [assetPrice, account]);

  const [docs, setDocs] = useState<any[]>([]);
  const { getDocuments } = useStore(accountStore);

  useEffect(() => {
    if (symbol) {
      getDocuments(symbol).then((data: any) => {
        setDocs(data.data);
      });
    } else {
      setDocs([]);
    }
  }, [symbol]);

  if (isInitialLoading) {
    return (
      <div className="stock-details stock-details">
        <div className="stock-details-header">
          <img
            className="go-back-portfolio"
            onClick={handleNavigate}
            src={GoBack}
            alt="Go Back"
          />
          <div>
            <p>{symbol}</p>
          </div>
        </div>
        <div className="stock-details-main">
          <p className="assets-loading assets-loading-page">{t("loading")}</p>
        </div>
      </div>
    );
  }

  if (symbol === "AMUITEB21ER9" && customInfo) {
    const bondConditions = [
      u("bondQuantity"),
      u("bondAnnualYield"),
      u("bondNominalValue"),
      u("bondTotalVolume"),
      u("bondCirculationPeriod"),
      u("bondCouponPayment"),
      u("bondRedemptionDate"),
    ];

    const acquisitionSteps = [
      u("step1Title"),
      u("step2Title"),
      u("step3Title"),
      u("step4Title"),
      u("step5Title"),
      u("step6Title"),
    ];

    const investmentAreas = [
      {
        title: u("investmentArea1Title"),
        description: u("investmentArea1Description"),
      },
      {
        title: u("investmentArea2Title"),
        description: u("investmentArea2Description"),
      },
      {
        title: u("investmentArea3Title"),
        description: u("investmentArea3Description"),
      },
      {
        title: u("investmentArea4Title"),
        description: u("investmentArea4Description"),
      },
    ];

    const faq = [
      {
        question: u("faq1Question"),
        answer: u("faq1Answer"),
      },
      {
        question: u("faq2Question"),
        answer: u("faq2Answer"),
      },
      {
        question: u("faq3Question"),
        answer: u("faq3Answer"),
      },
      {
        question: u("faq4Question"),
        answer: u("faq4Answer"),
      },
      {
        question: u("faq5Question"),
        answer: u("faq5Answer"),
      },
      {
        question: u("faq6Question"),
        answer: u("faq6Answer"),
      },
    ];

    return (
      <div className="strategy-page-no-loss strategy-page-uate">
        <div className="strategy-header-container">
          <div className="strategy-header">
            <img
              className="go-back-strategy"
              onClick={handleNavigate}
              src={GoBack}
              alt="Go Back"
            />
          </div>

          <img className="spy-banner" src={UATEBanner} alt="SPY Banner" />
        </div>

        <HorizontalScroll className="tab-bar tab-bar-cat">
          {(accountExists || pendingDeal) && (
            <TabBtn
              key="deals"
              text={t("deals")}
              active={activeTab === "deals"}
              onClick={() => handleTabClick("deals")}
            />
          )}

          {[
            ...tabs.map((tab, i) => ({
              key: `tab-${i + 1}`,
              title: getMLValue(tab.title, i18n.language) || "tab",
            })),
          ].map(({ key, title }) => (
            <TabBtn
              key={key}
              text={title}
              active={activeTab === key}
              onClick={() => handleTabClick(key)}
            />
          ))}
        </HorizontalScroll>

        <div className="strategy-main strategy-main-bond-details">
          {activeTab === "deals" ? (
            <div className="sm-tab-name sm-tab-trading">
              {accountExists && (
                <div className="current-investment-amount-strategy">
                  <label>{t("currentInvestmentAmount")}</label>
                  <p>
                    {accountExists
                      ? getTotalAmount()
                      : pendingDeal
                      ? formatPrice(
                          +(
                            assetDeals[0].quantity * assetDeals[0].price
                          ).toFixed(2),
                        )
                      : 0}
                    {currencySymbol}
                  </p>

                  {!pendingDeal && !!pnl && (
                    <span className={pnl > 0 ? "success" : "danger"}>
                      {pnl > 0 ? "+" : ""}
                      {pnl}
                      {currencySymbol}{" "}
                      {!!assetProgress && (
                        <>
                          ({assetProgress > 0 ? "+" : ""}
                          {assetProgress}%)
                        </>
                      )}
                    </span>
                  )}
                </div>
              )}

              {pendingDeal && (
                <div className="spy-strategy-pending-deal-info-block">
                  <img src={Info} alt="Info" />
                  <p>{i("applicationUnderReview")}</p>
                </div>
              )}

              {pendingDeal && (
                <ul
                  className="uate-strategy-pending-deal-info-list"
                  style={{ marginTop: "0px" }}
                >
                  <li>{i("weWillSendYouNotification")}</li>
                  <li>{i("afterApproval")}</li>
                </ul>
              )}

              <DealsTable assetId={strategy?.asset?.id || undefined} />

              {account && !pendingDeal && (
                <div className="strategy-dates-info">
                  {docs.length > 0 ? (
                    <div
                      className="date-info-item"
                      style={{ flexDirection: "column", gap: "8px" }}
                    >
                      {docs.map((report, index) => (
                        <>
                          <ReportItem
                            key={index}
                            url={report.file}
                            name={`${t("agreementFor")} (${report.date})`}
                          />
                          {index < docs.length - 1 && <hr />}
                        </>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </div>
          ) : activeTab === "tab-1" ? (
            <div className="sm-tab-name">
              <div className="strategy-main-bond-details_section-1">
                <p dangerouslySetInnerHTML={{ __html: u("heroFooter1") }} />
                <p dangerouslySetInnerHTML={{ __html: u("heroFooter2") }} />
                <p dangerouslySetInnerHTML={{ __html: u("heroFooter3") }} />
              </div>

              <div className="strategy-main-bond-details_section-2">
                <h4>{u("whatIsTitle")}</h4>
                <p>{u("whatIsDescription")}</p>
              </div>

              <div className="strategy-main-bond-details_section-3">
                <div>
                  <h5>{u("placementDatesTitle")}</h5>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: u("placementDatesDescription"),
                    }}
                  />
                </div>

                <img src={Calendar} alt="Calendar" />
              </div>

              <div className="strategy-main-bond-details_section-4">
                <div>
                  <h5>{u("bondConditionsTitle")}</h5>
                  <p>{u("bondClass")}</p>
                  <ul>
                    {bondConditions.map((item, index) => (
                      <li
                        key={index}
                        dangerouslySetInnerHTML={{ __html: item }}
                      />
                    ))}
                  </ul>
                </div>

                <div className="strategy-main-bond-details_section-4_logos">
                  <img src={UnionLogo} alt="UnionLogo" />
                  <img src={UiteIcon} alt="UiteLogo" />
                </div>
              </div>

              <div className="strategy-main-bond-details_section-5">
                <h4>{u("acquisitionProcessTitle")}</h4>

                <div className="strategy-main-bond-details_section-5_content">
                  {acquisitionSteps.map((item, index) => (
                    <div key={index}>
                      <img src={Checkmark} alt="Checkmark" />
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="strategy-main-bond-details_section-6">
                <div className="strategy-main-bond-details_section-6_content">
                  <h4>{u("benefitsTitle")}</h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: u("benefitsDescription1"),
                    }}
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: u("benefitsDescription2"),
                    }}
                  />
                </div>
              </div>

              <div className="strategy-main-bond-details_section-7">
                <h4
                  dangerouslySetInnerHTML={{
                    __html: u("investmentAreasTitle"),
                  }}
                />
                <p className="strategy-main-bond-details_section-7_description">
                  {u("investmentAreasDescription")}
                </p>

                <div className="strategy-main-bond-details_section-7_content">
                  {investmentAreas.map((item, index) => (
                    <div key={index}>
                      <p>{item.title}</p>
                      <span>{item.description}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="strategy-main-bond-details_section-8">
                <h4>{u("aboutUateExpoTitle")}</h4>
                <p
                  dangerouslySetInnerHTML={{
                    __html: u("aboutUateExpoDescription1"),
                  }}
                />
                <p>{u("aboutUateExpoDescription2")}</p>
              </div>

              <div className="uate-tab-3-about-sirius">
                <div>
                  <h4
                    dangerouslySetInnerHTML={{
                      __html: u("aboutSiriusTitle"),
                    }}
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: u("siriusDescription"),
                    }}
                  />
                </div>

                <img src={Mockup} alt="Mockup" />
              </div>

              <div className="strategy-main-bond-details_section-10">
                <h4>{u("additionalInfoTitle")}</h4>
                <p>
                  <a href={Doc2} target="__blank" rel="noreferrer">
                    {u("additionalInfo1")}
                  </a>
                </p>
                <p>
                  <a href={Doc1} target="__blank" rel="noreferrer">
                    {u("additionalInfo2")}
                  </a>
                </p>
                <p>
                  <a href={Doc3} target="__blank" rel="noreferrer">
                    {u("additionalInfo3")}
                  </a>
                </p>
                <p>
                  {u("additionalInfo4")}{" "}
                  <a href="tel:+37412300900">+374 12 300 900</a> /{" "}
                  <a href="tel:+37477300325">+374 77 300 325</a>
                </p>
              </div>
            </div>
          ) : activeTab === "tab-2" ? (
            <div className="sm-tab-name sm-tab-trading">
              <div className="strategy-main-bond-details_section-parameters">
                <h4>{u("keyParametersTitle")}</h4>
                <p
                  dangerouslySetInnerHTML={{
                    __html: u("keyParametersContent"),
                  }}
                />
              </div>

              <div className="strategy-main-bond-details_section-financials">
                <h4>{u("financialStatementsTitle")}</h4>
                <p
                  dangerouslySetInnerHTML={{
                    __html: u("financialStatementsContent"),
                  }}
                />
              </div>

              <div className="strategy-main-bond-details_section-prospectus">
                <h4>{u("prospectusTitle")}</h4>
                <p
                  dangerouslySetInnerHTML={{
                    __html: u("prospectusContent"),
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="sm-tab-name sm-tab-trading">
              <div className="strategy-main-bond-details_section-faq">
                <h4>{u("faqTitle")}</h4>

                <ul className="strategy-main-bond-details_section-11_content">
                  {faq.map((item, index) => (
                    <li
                      key={index}
                      className="strategy-main-bond-details_section-11_content_item"
                    >
                      <h5>
                        {index + 1}. {item.question}
                      </h5>
                      <p dangerouslySetInnerHTML={{ __html: item.answer }} />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>

        {/* {accountExists ? (
          <div className="strategy-action-btns-wrapper">
            <ActionBtn
              action={t("buy")}
              onClick={() =>
                action(() =>
                  handleDeal(assetInfo!.asset!.type, OperationType.Buy)
                )
              }
              type="dark"
              disabled={!enableTrading || !isExchangeActive}
            />
            <ActionBtn
              action={t("sell")}
              onClick={() =>
                action(() =>
                  handleDeal(assetInfo!.asset!.type, OperationType.Sell)
                )
              }
              disabled={!enableTrading || !isExchangeActive}
            />
          </div>
        ) : ( */}
        <div className="btn-wrapper deal-btn-wrapper">
          <Button
            type="submit"
            variant="dark"
            className="customBtn deal-btn"
            disabled={!enableTrading || !isExchangeActive}
            onClick={() =>
              action(() =>
                handleDeal(assetInfo!.asset!.type, OperationType.Buy),
              )
            }
          >
            {u("buyBondButton")}
          </Button>
        </div>
        {/* )} */}
      </div>
    );
  }

  if (symbol === "AMNAGCB22SH1" && customInfo) {
    const NAGCB2_PROSPECTUS_URL =
      "https://cdn-front.siriuscapital.am/static/media/%D4%BE%D5%90%D4%B1%D4%B3%D5%90%D4%B1%D5%85%D4%BB%D5%86%20%D4%B1%D4%B6%D4%B4%D4%B1%D4%B3%D4%BB%D5%90_%D5%86%D5%85%D5%88%D5%92%20%D4%B7%D5%85%D5%8B%20%D5%94%D5%88%D5%86%D5%8D%D4%B9%D5%90%D4%B1%D5%94%D5%87%D5%86%20%D5%8D%D5%8A%D4%B8-%D5%BE%D5%A5%D6%80%D5%BB%D5%B6%D5%A1%D5%AF%D5%A1%D5%B6%20(2).540fde9fc60850a2d693.pdf";
    const NAGCB2_FINAL_TERMS_URL =
      "https://cdn-front.siriuscapital.am/static/media/%D5%86%D5%B5%D5%B8%D6%82%20%D4%B7%D5%B5%D5%BB%E2%80%94%D5%8E%D5%A5%D6%80%D5%BB%D5%B6%D5%A1%D5%AF%D5%A1%D5%B6%20%D5%8A%D5%A1%D5%B5%D5%B4%D5%A1%D5%B6%D5%B6%D5%A5%D6%80%20%D5%8D%D5%BF%D5%B8%D6%80%D5%A1%D5%A3%D6%80%D5%BE%D5%A1%D5%AE.c763c628473e7168db11.pdf";

    const nagcb2Tabs = [
      { key: "tab-1", title: n("tabDescription") },
      { key: "tab-2", title: n("tabDocuments") },
      { key: "tab-3", title: n("tabFaq") },
    ];
    const issuanceTerms = [
      n("issuanceTermIssuer"),
      n("issuanceTermPlacementAgent"),
      n("issuanceTermAnnualCoupon"),
      n("issuanceTermCouponPayments"),
      n("issuanceTermTerm"),
      n("issuanceTermTotalIssueSize"),
      n("issuanceTermNominalValue"),
      n("issuanceTermCurrency"),
      n("issuanceTermTaxTreatment"),
      n("issuanceTermNumberOfBonds"),
      n("issuanceTermPlacementStartDate"),
      n("issuanceTermMaturityDate"),
    ];

    const acquisitionSteps = [
      n("step1Title"),
      n("step2Title"),
      n("step3Title"),
      n("step4Title"),
      n("step5Title"),
    ];

    const faq = [
      {
        question: n("faq1Question"),
        answer: n("faq1Answer"),
      },
      {
        question: n("faq2Question"),
        answer: n("faq2Answer"),
      },
      {
        question: n("faq3Question"),
        answer: n("faq3Answer"),
      },
      {
        question: n("faq4Question"),
        answer: n("faq4Answer"),
      },
      {
        question: n("faq5Question"),
        answer: n("faq5Answer"),
      },
    ];

    return (
      <div className="strategy-page-no-loss strategy-page-uate">
        <div className="strategy-header-container">
          <div className="strategy-header">
            <img
              className="go-back-strategy"
              onClick={handleNavigate}
              src={GoBack}
              alt="Go Back"
            />
          </div>

          <img className="spy-banner" src={NAGCB2Banner} alt="Banner" />
        </div>

        <HorizontalScroll className="tab-bar tab-bar-cat">
          {(accountExists || pendingDeal) && (
            <TabBtn
              key="deals"
              text={t("deals")}
              active={activeTab === "deals"}
              onClick={() => handleTabClick("deals")}
            />
          )}

          {nagcb2Tabs.map(({ key, title }) => (
            <TabBtn
              key={key}
              text={title}
              active={activeTab === key}
              onClick={() => handleTabClick(key)}
            />
          ))}
        </HorizontalScroll>

        <div className="strategy-main strategy-main-bond-details">
          {activeTab === "deals" ? (
            <div className="sm-tab-name sm-tab-trading">
              {accountExists && (
                <div className="current-investment-amount-strategy">
                  <label>{t("currentInvestmentAmount")}</label>
                  <p>
                    {accountExists
                      ? getTotalAmount()
                      : pendingDeal
                      ? formatPrice(
                          +(
                            assetDeals[0].quantity * assetDeals[0].price
                          ).toFixed(2),
                        )
                      : 0}
                    {currencySymbol}
                  </p>

                  {!pendingDeal && !!pnl && (
                    <span className={pnl > 0 ? "success" : "danger"}>
                      {pnl > 0 ? "+" : ""}
                      {pnl}
                      {currencySymbol}{" "}
                      {!!assetProgress && (
                        <>
                          ({assetProgress > 0 ? "+" : ""}
                          {assetProgress}%)
                        </>
                      )}
                    </span>
                  )}
                </div>
              )}

              {pendingDeal && (
                <div className="spy-strategy-pending-deal-info-block">
                  <img src={Info} alt="Info" />
                  <p>{n("applicationUnderReview")}</p>
                </div>
              )}

              {pendingDeal && (
                <ul
                  className="uate-strategy-pending-deal-info-list"
                  style={{ marginTop: "0px" }}
                >
                  <li>{n("weWillSendYouNotification")}</li>
                  <li>{n("afterApproval")}</li>
                </ul>
              )}

              <DealsTable assetId={strategy?.asset?.id || undefined} />

              {account && !pendingDeal && (
                <div className="strategy-dates-info">
                  {docs.length > 0 ? (
                    <div
                      className="date-info-item"
                      style={{ flexDirection: "column", gap: "8px" }}
                    >
                      {docs.map((report, index) => (
                        <>
                          <ReportItem
                            key={index}
                            url={report.file}
                            name={`${t("agreementFor")} (${report.date})`}
                          />
                          {index < docs.length - 1 && <hr />}
                        </>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </div>
          ) : activeTab === "tab-1" ? (
            <div className="sm-tab-name">
              <div className="strategy-main-bond-details_section-1">
                <h4>{n("heroTitle")}</h4>
                <p>{n("heroDescription1")}</p>
                <p>{n("heroDescription2")}</p>
              </div>

              <div className="strategy-main-bond-details_section-3">
                <div>
                  <h5>{n("placementDatesTitle")}</h5>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: n("placementDatesDescription"),
                    }}
                  />
                </div>

                <img src={Calendar} alt="Calendar" />
              </div>

              <div className="strategy-main-bond-details_section-4">
                <div>
                  <h5>{n("issuanceTermsTitle")}</h5>
                  <ul>
                    {issuanceTerms.map((item, index) => (
                      <li
                        key={index}
                        dangerouslySetInnerHTML={{ __html: item }}
                      />
                    ))}
                  </ul>
                  <p
                    className="strategy-main-bond-details_tax-footnote"
                    dangerouslySetInnerHTML={{
                      __html: n("issuanceTermTaxFootnote1"),
                    }}
                  />
                  <p
                    className="strategy-main-bond-details_tax-footnote"
                    dangerouslySetInnerHTML={{
                      __html: n("issuanceTermTaxFootnote2"),
                    }}
                  />
                </div>
              </div>

              <div className="strategy-main-bond-details_section-5">
                <h4>{n("acquisitionProcessTitle")}</h4>
                <p>{n("acquisitionProcessIntro")}</p>

                <div className="strategy-main-bond-details_section-5_content">
                  {acquisitionSteps.map((item, index) => (
                    <div key={index}>
                      <img src={Checkmark} alt="Checkmark" />
                      <p>
                        {index + 1}. {item}
                      </p>
                    </div>
                  ))}
                </div>

                <p
                  className="strategy-main-bond-details_footnote"
                  dangerouslySetInnerHTML={{
                    __html: n("acquisitionProcessFootnote"),
                  }}
                />
              </div>

              <div className="strategy-main-bond-details_section-8">
                <h4>{n("aboutIssuerTitle")}</h4>
                <p>{n("aboutIssuerDescription1")}</p>
                <p>{n("aboutIssuerDescription2")}</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: n("aboutIssuerWebsite"),
                  }}
                />
              </div>

              <div className="strategy-main-bond-details_section-6">
                <div className="strategy-main-bond-details_section-6_content">
                  <h4>{n("firstIssuanceTitle")}</h4>
                  <p>{n("firstIssuanceDescription1")}</p>
                  <p>{n("firstIssuanceDescription2")}</p>
                  <p>{n("firstIssuanceDescription3")}</p>
                </div>
              </div>

              <div className="strategy-main-bond-details_section-7">
                <h4>{n("useOfProceedsTitle")}</h4>
                <p className="strategy-main-bond-details_section-7_description">
                  {n("useOfProceedsDescription1")}
                </p>
                <p className="strategy-main-bond-details_section-7_description">
                  {n("useOfProceedsDescription2")}
                </p>
              </div>
            </div>
          ) : activeTab === "tab-2" ? (
            <div className="sm-tab-name sm-tab-trading">
              <div className="strategy-main-bond-details_section-prospectus">
                <p
                  dangerouslySetInnerHTML={{
                    __html: n("documentsIntro"),
                  }}
                />
                <ul className="strategy-main-bond-details_documents-list">
                  <li>
                    {n("documentsProspectusLabel")}{" "}
                    <a
                      href={NAGCB2_PROSPECTUS_URL}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {n("documentsProspectusLinkText")}
                    </a>
                  </li>
                  <li>
                    {n("documentsFinalTermsLabel")}
                    <a
                      href={NAGCB2_FINAL_TERMS_URL}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {n("documentsFinalTermsLinkText")}
                    </a>
                  </li>
                </ul>
                <p
                  dangerouslySetInnerHTML={{
                    __html: n("documentsDisclaimer"),
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="sm-tab-name sm-tab-trading">
              <div className="strategy-main-bond-details_section-faq">
                <h4>{n("faqTitle")}</h4>

                <ul className="strategy-main-bond-details_section-11_content">
                  {faq.map((item, index) => (
                    <li
                      key={index}
                      className="strategy-main-bond-details_section-11_content_item"
                    >
                      <h5>
                        {index + 1}. {item.question}
                      </h5>
                      <p dangerouslySetInnerHTML={{ __html: item.answer }} />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>

        <div className="btn-wrapper deal-btn-wrapper">
          <Button
            type="submit"
            variant="dark"
            className="customBtn deal-btn"
            disabled={!enableTrading || !isExchangeActive}
            onClick={() =>
              action(() =>
                handleDeal(assetInfo!.asset!.type, OperationType.Buy),
              )
            }
          >
            {n("investNowButton")}
          </Button>
        </div>
      </div>
    );
  }

  if (customInfo) {
    return (
      <div className="strategy-page bond-strategy-page">
        {customInfo && customInfo?.info?.header_image ? (
          <div
            className={`strategy-header-container strategy-header-container-${risk}`}
            style={{
              backgroundImage: `url(${getCdnUrl(
                `${symbol}/${customInfo?.info?.header_image}`,
                "strategy",
              )})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="strategy-header">
              <img
                className="go-back-strategy"
                onClick={handleNavigate}
                src={GoBack}
                alt="Go Back"
              />
            </div>
          </div>
        ) : (
          <div
            className={`strategy-header-container strategy-header-container-${risk}`}
            style={{
              background: customInfo
                ? `linear-gradient(256.2deg, ${customInfo.info.background.to} -7.74%, ${customInfo.info.background.from} 100%)`
                : "",
              ...(customInfo?.info?.hide_header_cards && {
                minHeight: "72px",
                height: "72px",
              }),
            }}
          >
            <div className="strategy-header">
              <img
                className="go-back-strategy"
                onClick={handleNavigate}
                src={GoBack}
                alt="Go Back"
              />
              <p>{strategy?.asset?.name}</p>
            </div>
            {customInfo && customInfo?.info?.hide_header_cards ? (
              <></>
            ) : (
              <div className="strategy-header-info">
                {customInfo?.info?.header_cards ? (
                  customInfo?.info?.header_cards?.map((hc) => (
                    <div className="sh-info-box">
                      {getMLValue(hc.p, i18n.language) && (
                        <p>{getMLValue(hc.p, i18n.language)}</p>
                      )}
                      {getMLValue(hc.span, i18n.language) && (
                        <span>{getMLValue(hc.span, i18n.language)}</span>
                      )}
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>
            )}
          </div>
        )}

        <HorizontalScroll className="tab-bar tab-bar-cat">
          {[
            ...tabs.map((tab, i) => ({
              key: `tab-${i + 1}`,
              title: getMLValue(tab.title, i18n.language) || "tab",
            })),
          ].map(({ key, title }) => (
            <TabBtn
              key={key}
              text={title}
              active={activeTab === key}
              onClick={() => handleTabClick(key)}
            />
          ))}
        </HorizontalScroll>

        <div
          className="strategy-main"
          style={{ paddingTop: customInfo ? "0px" : "24px" }}
        >
          {!customInfo ? (
            <div className="sm-info-container">
              {/* <StrategyChart
                chart={strategy?.chart}
                title={chartSymbol ? `${chartSymbol} stock chart` : undefined}
              /> */}
              <DealsTable assetId={strategy?.asset?.id || undefined} />
            </div>
          ) : activeTabContent ? (
            <div className="sm-tab-name">
              {activeTabContent?.data?.map((item, index) => {
                if (item.type === "companies_list") {
                  return (
                    <Swiper
                      style={{ width: "100%", padding: "16px 24px" }}
                      wrapperClass="strategy-indicator-box"
                      spaceBetween={12}
                      slidesPerView={1.1}
                      scrollbar={{ draggable: true }}
                    >
                      {item.value.map((param, index) => (
                        <SwiperSlide key={index}>
                          <div className="indicator-box">
                            <div
                              style={{
                                display: "flex",
                                gap: "12px",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "6px",
                              }}
                            >
                              <img
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  borderRadius: "100%",
                                }}
                                src={getCdnUrl(
                                  `${strategy?.asset?.symbol || ""}/${
                                    param.logo
                                  }`,
                                  "strategy",
                                )}
                                alt={param.name}
                              />
                              <p>{param.name}</p>
                            </div>
                            {param.data.map((param, index) => (
                              <div key={index} className="indicator-box-row">
                                <span
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  {getMLValue(param.label, i18n.language)}
                                </span>
                                <span
                                  style={{
                                    fontWeight: 600,
                                    color: " #131722",
                                    textAlign: "right",
                                  }}
                                >
                                  {getMLValue(param.value, i18n.language)}
                                </span>
                              </div>
                            ))}
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  );
                } else if (item.type === "references_list") {
                  return item.value.map((param: any, index: any) => (
                    <p
                      style={{ textAlign: "left", fontSize: "14px" }}
                      key={index}
                      dangerouslySetInnerHTML={{
                        __html: getMLValue(param.value),
                      }}
                    />
                  ));
                } else if (item.type === "text") {
                  return (
                    <div key={index} className="review-title">
                      {item.label && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: getMLValue(item.label, i18n.language),
                          }}
                        />
                      )}
                      <span
                        className="description-span"
                        dangerouslySetInnerHTML={{
                          __html: getMLValue(item.value, i18n.language),
                        }}
                      />
                    </div>
                  );
                } else if (item.type === "params") {
                  return (
                    <div key={index}>
                      <div className="review-title">
                        {item.label && (
                          <p>{getMLValue(item.label, i18n.language)}</p>
                        )}
                      </div>

                      {item.value.map((param: any, paramIndex: number) => (
                        <ReviewDetails
                          key={paramIndex}
                          title={getMLValue(param.label, i18n.language)}
                          info={getMLValue(param.value, i18n.language)}
                          type={param.type == "array" ? param.value : null}
                        />
                      ))}
                    </div>
                  );
                } else if (item.type === "image") {
                  return (
                    <div key={index} className="review-title">
                      {item.description && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: getMLValue(item.description, i18n.language),
                          }}
                        />
                      )}
                      {item.label && (
                        <p>{getMLValue(item.label, i18n.language)}</p>
                      )}
                      {item.text && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: getMLValue(item.text, i18n.language),
                          }}
                        />
                      )}
                      <img
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                        }}
                        src={getCdnUrl(
                          `${symbol}/${getMLValue(item.value, i18n.language)}`,
                          "strategy",
                        )}
                        alt="Image"
                      />
                      {item.caption && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: getMLValue(item.caption, i18n.language),
                          }}
                        />
                      )}
                    </div>
                  );
                } else if (item.type === "list") {
                  return (
                    <div key={index} className="review-title">
                      {item.label && (
                        <p className="review-list-label">
                          {getMLValue(item.label, i18n.language)}
                        </p>
                      )}
                      {item.text && (
                        <span
                          className="review-list-info"
                          dangerouslySetInnerHTML={{
                            __html: getMLValue(item.text, i18n.language),
                          }}
                        />
                      )}
                      <ul>
                        {item.value.map((listItem: any, listIndex: number) => (
                          <li
                            key={listIndex}
                            dangerouslySetInnerHTML={{
                              __html: getMLValue(listItem, i18n.language),
                            }}
                          />
                        ))}
                      </ul>
                    </div>
                  );
                } else if (item.type === "companies") {
                  return (
                    <div key={index} className="review-title">
                      <p>{getMLValue(item.label, i18n.language)}</p>
                      {item.value.map((company: any, companyIndex: number) => (
                        <div
                          key={companyIndex}
                          className="review-title-content"
                        >
                          <p>{getMLValue(company.name, i18n.language)}</p>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: getMLValue(
                                company.description,
                                i18n.language,
                              ),
                            }}
                          />
                          {company?.images?.map((image: any, index: number) => (
                            <img
                              key={index}
                              src={getCdnUrl(
                                `${symbol}/${getMLValue(image, i18n.language)}`,
                                "strategy",
                              )}
                              alt={getMLValue(image, i18n.language)}
                            />
                          ))}
                        </div>
                      ))}
                    </div>
                  );
                } else if (item.type === "disclaimer") {
                  return (
                    <div className="indicators-title review-title">
                      <span className="description-span">
                        {getMLValue(item.text, i18n.language)}
                      </span>
                    </div>
                  );
                } else if (item.type === "references") {
                  return item.value.map((param) => (
                    <div key={index} className="indicators-info">
                      <p style={{ fontSize: "14px" }}>
                        {getMLValue(param.title, i18n.language)}
                      </p>
                      <span>
                        {t("sources")} {/* @ts-ignore */}
                        {param.list.map((item, index) => (
                          <span
                            style={{ fontWeight: 600, fontSize: "13px" }}
                            key={index}
                          >
                            {getMLValue(item.label, i18n.language)}
                            {index < param.list.length - 1 && ", "}
                          </span>
                        ))}
                      </span>
                      <ul>
                        {param.list.map((item, idx) => (
                          <li key={idx}>
                            <a
                              href={item.link[i18n.language]}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {getMLValue(item.link, i18n.language)}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ));
                }
              })}
            </div>
          ) : (
            <></>
          )}
        </div>

        {accountExists ? (
          <div className="strategy-action-btns-wrapper">
            {customInfo?.info?.hide_increase_decrease ? (
              <></>
            ) : (
              <>
                <ActionBtn
                  action="Increase"
                  onClick={() =>
                    action(() =>
                      handleDeal(assetInfo!.asset!.type, OperationType.Buy),
                    )
                  }
                  type="dark"
                  disabled={!enableTrading}
                />
                <ActionBtn
                  action="Decrease"
                  onClick={() =>
                    action(() =>
                      handleDeal(assetInfo!.asset!.type, OperationType.Sell),
                    )
                  }
                  disabled={!enableTrading}
                />
              </>
            )}
          </div>
        ) : (
          <div className="btn-wrapper deal-btn-wrapper">
            <Button
              type="submit"
              variant="dark"
              className="customBtn deal-btn"
              disabled={!enableTrading}
              onClick={() =>
                action(() =>
                  handleDeal(assetInfo!.asset!.type, OperationType.Buy),
                )
              }
            >
              {t("invest")}
            </Button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="bond-details">
      {showNotification && <SavedToFavNotification symbol={symbol} />}

      <div className="bond-details-header">
        <img
          className="go-back-portfolio"
          onClick={handleNavigate}
          src={GoBack}
          alt="Go Back"
        />
        <div className="stock-details-header-info">
          <AssetIcon
            asset={{
              type: assetType,
              image: assetInfo?.asset?.image || "",
              symbol: symbol!,
            }}
            className="asset-logo"
          />
          <p>
            {symbol}
            <span>({assetInfo?.asset?.name || ""})</span>
          </p>
        </div>

        {/* @ts-ignore */}
        <SaveToFavBtn onclick={() => handleSave(asset_id)} saved={saved} />
      </div>

      {enableOrderbook && (
        <HorizontalScroll className="tab-bar">
          <TabBtn
            text={t("trading")}
            active={activeTab2 === "Trading"}
            onClick={() => handleTab2Click("Trading")}
          />
          <TabBtn
            text={t("depth")}
            active={activeTab2 === "Depth"}
            onClick={() => handleTab2Click("Depth")}
          />
        </HorizontalScroll>
      )}

      {activeTab2 === "Trading" ? (
        <div
          className="bond-details-main bond-details-mainbonds-bargaining"
          style={{
            marginTop: enableOrderbook ? "0" : " var(--inset-top, 0px)",
          }}
        >
          {assetInfo?.bondInfo?.is_otc && (
            <div className="bargaining-alert">
              <span>{t("tradingInOTCMode")}</span>
            </div>
          )}

          <div className="bond-info-bargaining">
            <div>
              <div className="gain-percent">
                <p className="price">{ask_yield ? `${ask_yield}%` : ""}</p>
                <p className="price gains-percent">{ask || last}</p>
                {exchange && (
                  <ExchangeStatusBtn
                    onClick={() => setStockStatus(true)}
                    status={exchange.status}
                  />
                )}
              </div>
            </div>
            {exchange && (
              <ExchangeSource
                name={exchange.exchange_name}
                code={exchange.exchange_code}
                image={exchange.exchange_logo}
              />
            )}
          </div>

          <MarketChart />

          {enableOrderbook && bestAssetDepth.length > 0 && (
            <AssetWidgetAndBottomSheet
              title="depth"
              customClick={() => {
                setActiveTab2("Depth");
              }}
              htmlContent={
                <div className="depth-main">
                  <div
                    className="depth-main-header"
                    style={{ position: "static" }}
                  >
                    <p>{t("purchase")}</p>
                    <p>{t("price")}</p>
                    <p>{t("sale")}</p>
                  </div>
                  <div className="depth-content">
                    {bestAssetDepth.map((item, index) => {
                      return (
                        <DepthField
                          key={index}
                          purchase={
                            item.operation === "sell"
                              ? item.quantity
                              : undefined
                          }
                          price={item.price + "%"}
                          sale={
                            item.operation === "buy" ? item.quantity : undefined
                          }
                          progress={item.progress}
                          currency={
                            item.yield ? `${+item.yield.toFixed(2)}%` : ""
                          }
                          onClick={() => {
                            navigate(
                              PATH_LIST[item.operation](asset_id) +
                                `?type=${assetInfo!.asset!.type}&price=${
                                  item.price
                                }` +
                                // Доходность уровня относится ИМЕННО к этой
                                // цене. Без неё терминал показывал бы рыночную
                                // доходность, не совпадающую с подставленной
                                // ценой.
                                (item.yield != null
                                  ? `&yield=${item.yield}`
                                  : ""),
                            );
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              }
            />
          )}

          <DealsTable assetId={assetInfo?.asset?.id || undefined} />

          <div className="action-btns-main-wrapper">
            <ActionBtn
              customClass
              onClick={() =>
                action(() =>
                  handleDeal(assetInfo!.asset!.type, OperationType.Buy),
                )
              }
              action={t("buy")}
              price={ask}
              type="green"
              disabled={!isExchangeActive || isMatured}
            />
            <ActionBtn
              customClass
              type="red"
              onClick={() =>
                action(() =>
                  handleDeal(assetInfo!.asset!.type, OperationType.Sell),
                )
              }
              action={t("sell")}
              price={bid}
              disabled={!isExchangeActive || isMatured || isEmpty}
            />
          </div>

          {isEmpty ? infoComponents : infoComponents.reverse()}

          {stockStatus && exchange && (
            <ExchangeStatusComp
              tf={exchange}
              onClose={() => setStockStatus(false)}
            />
          )}
        </div>
      ) : (
        <div
          className="bond-details-main stock-details-main-review"
          style={{
            marginTop: enableOrderbook ? "0" : " var(--inset-top, 0px)",
          }}
        >
          <div className="depth-header">
            <p>{t("depthOfMarket")}</p>
          </div>

          <div className="depth-main">
            <div className="depth-main-header">
              <p>{t("purchase")}</p>
              <p>{t("price")}</p>
              <p>{t("sale")}</p>
            </div>
            <div className="depth-content">
              {assetDepth.map((item, index) => {
                return (
                  <DepthField
                    key={index}
                    purchase={
                      item.operation === "sell" ? item.quantity : undefined
                    }
                    price={item.price + "%"}
                    sale={item.operation === "buy" ? item.quantity : undefined}
                    progress={item.progress}
                    currency={item.yield ? `${+item.yield.toFixed(2)}%` : ""}
                    onClick={() => {
                      navigate(
                        PATH_LIST[item.operation](asset_id) +
                          `?type=${assetInfo!.asset!.type}&price=${item.price}` +
                          (item.yield != null ? `&yield=${item.yield}` : ""),
                      );
                    }}
                  />
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
